var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_737_26364)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.464 9.64008C22.716 5.43875 18.604 2.66675 14 2.66675C7.75067 2.66675 2.66667 7.75075 2.66667 14.0001C2.66667 14.7347 2.73733 15.4627 2.876 16.1774C1.08 17.5534 0 19.7054 0 22.0001C0 26.0427 2.99067 29.3334 6.66667 29.3334H22C27.5147 29.3334 32 24.8481 32 19.3334C32 14.7107 28.8747 10.7521 24.464 9.64008ZM20.3907 19.0561L17.3333 15.9987V23.9987H14.6667V15.9987L11.6093 19.0561L9.724 17.1707L14.1147 12.7801C15.1533 11.7414 16.8467 11.7414 17.8853 12.7801L22.276 17.1707L20.3907 19.0561Z",
    fill: "#808B99"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_737_26364"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.c8c088dfbd41f3aba9b9b9258fadbd13.svg";
export { ForwardRef as ReactComponent };